/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";

// import SideBar from "./SideBar";
import "./Style.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Footer from "../component/Footer";
import { Link, Navigate } from "react-router-dom";
import SearchHead from "./SearchHead";
import { useSelector, useDispatch } from "react-redux";
import { orderActions } from "../_actions";
// import { alertActions } from "../_actions";
import { changeDateFormatFrench, convertNumberFrench } from "../_helpers";
// import { MdModeEditOutline } from "react-icons/md";
// import { BsCreditCard2Back } from "react-icons/bs";
// import { HiOutlineDownload } from "react-icons/hi";

import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import ScreenWrapper from "./ScreenWrapper";
import PageLoaderComp from "../component/pageLoaderComp";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
export default function AnnoncesPubliees() {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.authentication.user);
  const orders = useSelector((state) => state.orders.devis);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [TabHead, setTabHead] = useState([
    "DENOMINATION",
    "FORMULAIRE",
    "JOURNAL",
    "MONTANT",
    "DATE DE CRÉATION",
    /* 'INVOICE',
    'ATTESTATION',
    'ATTESTATION' */
  ]);

  const [TabData, setTabData] = useState([]);
  const [totalRows, setTotalRows] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    getAllDevise();
  }, []);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - TabData.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getAllDevise = () => {
    setPageLoading(true);
    dispatch(orderActions.getAll(currentUser.data.id, "devis"))
      .then((data) => {
        setPageLoading(false);
        setTabData(data);
        setTotalRows(data);
      })
      .catch(() => {
        setPageLoading(false);
      });
  };

  if (!currentUser) {
    return <Navigate to="/" />;
  }
  return (
    <>
      {pageLoading ? <PageLoaderComp /> : ""}
      <ScreenWrapper>
        <div className="max-w-[1126px] w-full h-full bg-white rounded-[20px]">
          <div className="mainHead min-h-[80px] sm:min-h-[120px] flex sm:flex-row flex-col sm:items-center p-3 sm:p-8 sm:justify-between">
            <div>
              <h1 className="text-lg sm:text-xl md:text-lg xl:text-xl 2xl:text-xl font-extrabold text-white sm:mt-0 mt-4">
                Annonces publiées
              </h1>
            </div>
            <div className="w-full sm:w-auto flex justify-end">
              <SearchHead
                setTotalRows={setTotalRows}
                totalRows={totalRows}
                setTabData={setTabData}
              />
            </div>
          </div>

          <div className="mt-8 sm:px-9 px-4 hidden lg:block">
            <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
              <Table
                sx={{
                  minWidth: 650,
                  /*  borderCollapse: "separate",
                  borderSpacing: " 0 15px", */
                }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {TabHead.map((thItem, i) => {
                      return (
                        <TableCell
                          key={i}
                          className="text-base font-normal text-black-light whitespace-nowrap"
                        >
                          {thItem}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? TabData.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : TabData
                  ).map((tdItem, i) => {
                    let ann_details_url = `/userdashboard/annonces-publiees-details/${tdItem.id}`;
                    return (
                      <TableRow
                        key={i}
                        /*  className="bg-[#F9F9F9]  "
                        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }} */
                      >
                        {/* annonces-publiees-details */}

                        <TableCell
                          className="text-base font-normal text-primary whitespace-nowrap"
                          align="left"
                        >
                          <Link to={ann_details_url}>{tdItem.username}</Link>{" "}
                        </TableCell>
                        <TableCell
                          className="text-base font-normal text-primary whitespace-nowrap"
                          align="left"
                        >
                          {/* {tdItem.form_type} */}

                          <Link to={ann_details_url}>{tdItem.form_type}</Link>
                        </TableCell>
                        <TableCell
                          className="text-base font-normal text-primary whitespace-nowrap"
                          align="left"
                        >
                          <Link to={ann_details_url}>
                            {tdItem.journal_detail}
                          </Link>
                        </TableCell>
                        <TableCell
                          className="text-base font-normal text-primary whitespace-nowrap"
                          align="left"
                        >
                          <Link to={ann_details_url}>
                            {convertNumberFrench(tdItem.total)} €
                          </Link>
                        </TableCell>
                        <TableCell
                          className="text-base font-normal text-primary whitespace-nowrap"
                          align="left"
                        >
                          <Link to={ann_details_url}>
                            {changeDateFormatFrench(tdItem.creation_date)}
                          </Link>{" "}
                        </TableCell>
                        {/* <TableCell className='text-base font-normal text-primary whitespace-nowrap' align="left">
                              <Link target={"_blank"} alt={tdItem.votre_pdf} to={process.env.REACT_APP_API_URL+'uploads/pdfgenerate/invoice/'+tdItem.votre_pdf} rel="noopener noreferrer">
                                <HiOutlineDownload className='w-5 h-5' />
                              </Link>
                            </TableCell> */}
                        {/* <TableCell className='text-base font-normal text-primary whitespace-nowrap' align="left">
                              <Link target={"_blank"} alt={tdItem.attestation} to={process.env.REACT_APP_API_URL+'uploads/pdfgenerate/attestation/'+tdItem.attestation} rel="noopener noreferrer">
                                <HiOutlineDownload className='w-5 h-5' />
                              </Link>
                            </TableCell> */}
                        {/* <TableCell className='text-base font-normal text-primary whitespace-nowrap' align="left">
                              <Link target={"_blank"} alt={tdItem.votre_pdf} to={process.env.REACT_APP_API_URL+'uploads/pdfgenerate/invoice/'+tdItem.votre_pdf} rel="noopener noreferrer">
                                <HiOutlineDownload className='w-5 h-5' />
                              </Link>
                            </TableCell> */}
                      </TableRow>
                    );
                  })}
                  {TabData.length <= 0 && (
                    <TableRow /* style={{ height: 53 * emptyRows }} */>
                      <TableCell colSpan={6}>
                        <p className="text-center font-bold capitalize text-lg">
                          Aucune donnée!
                        </p>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "All", value: -1 },
                      ]}
                      // colSpan={3}
                      count={TabData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          "aria-label": "rows per page",
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>

          <div className="mt-8  block lg:hidden">
            {(rowsPerPage > 0
              ? TabData.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : TabData
            ).map((tdItem, i) => {
              let ann_details_url = `/userdashboard/annonces-publiees-details/${tdItem.id}`;
              return (
                <div
                  className="flex w-full flex-col justify-center gap-5 items-center bg-white rounded-[20px] shadow-md  p-3 mt-4"
                  style={{ border: "1px solid #d9d9d9" }}
                >
                  <div className="flex flex-col justify-start items-start w-full">
                    <div className="text-black-light font-medium">
                      DENOMINATION
                    </div>
                    <div>
                      <Link to={ann_details_url}>{tdItem.username}</Link>
                    </div>
                  </div>

                  <div className="flex flex-col justify-start items-start w-full">
                    <div className="text-black-light font-medium">
                      FORMULAIRE
                    </div>
                    <div>
                      {" "}
                      <Link to={ann_details_url}>{tdItem.form_type}</Link>
                    </div>
                  </div>
                  <div className="flex flex-col justify-start items-start w-full">
                    <div className="text-black-light font-medium">JOURNAL</div>
                    <div>
                      {" "}
                      <Link to={ann_details_url}>{tdItem.journal_detail}</Link>
                    </div>
                  </div>
                  <div className="flex flex-col justify-start items-start w-full">
                    <div className="text-black-light font-medium">MONTANT</div>
                    <div>
                      <Link to={ann_details_url}>
                        {convertNumberFrench(tdItem.total)} €
                      </Link>
                    </div>
                  </div>
                  <div className="flex flex-col justify-start items-start w-full">
                    <div className="text-black-light font-medium">
                      DATE DE CRÉATION
                    </div>
                    <div>
                      {" "}
                      <Link to={ann_details_url}>
                        {changeDateFormatFrench(tdItem.creation_date)}
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}

            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  // colSpan={3}
                  count={TabData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: false,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </div>
        </div>
      </ScreenWrapper>
      <Footer />
    </>
  );
}
